import type { ChangeEvent } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

import { AdminTable } from '@/components/shared/AdminTable'

import { AdminToggle } from './AdminToggle'

export type ToggleListOption<T extends string> = {
  value: T
  label: string
  enabled: boolean
}
type Props<T extends string> = PropsWithClassName<{
  list: ToggleListOption<T>[]
  onChange: (newList: ToggleListOption<T>[]) => void
}>

export const AdminToggleList = <T extends string>(props: Props<T>) => {
  const { list, onChange } = props
  const createToggleHandler =
    (option: ToggleListOption<T>) =>
    async (e: ChangeEvent<HTMLInputElement>) => {
      onChange(
        list.map(o => ({
          ...o,
          ...(o.value === option.value && { enabled: e.target.checked }),
        })),
      )
    }
  return (
    <div>
      <AdminTable
        data={list}
        defaultSort="label"
        columns={[
          {
            key: 'enabled',
            className: 'w-10',
            render: row => (
              <AdminToggle
                className="toggle-xs"
                id={row.value}
                checked={row.enabled}
                onChange={createToggleHandler(row)}
              />
            ),
          },
          {
            key: 'label',
            render: row => (
              <label htmlFor={row.value} className="cursor-pointer">
                {row.label}
              </label>
            ),
          },
        ]}
        rowKey={r => r.value}
      />
    </div>
  )
}
